import { useRecoilState, atom } from "recoil";


import appConfig from "../../config/app.config";
import { API_STATUS } from "../../constants/app.constants";

import useRestApiCall from "../../http.interceptor";


const { LOADING, SUCCESS, ERROR } = API_STATUS;

const USER_INFO_INITIAL_STATE = {
  status: LOADING,
  content: {},
};

const userInfoAtom = atom({
  key: "userInfoState",
  default: USER_INFO_INITIAL_STATE,
});

const userInfoPayload = () => {

  let apiPayload = {
    method: "GET",

    url: "/api/auth/userinfo",
    baseURL: appConfig.apiMarketplaceBaseUrl,
    headers: {
      Accept: "application/json",
    },
  };
  return apiPayload;
};

const useFetchUserInfo = () => {
  const { apiCall } = useRestApiCall();
  
 const [userInfoState, setUserInfoState] = useRecoilState(userInfoAtom);
  const { status, content } = userInfoState;

  const fetchUserInfo = async (accessToken) => {
    try {
      const payload = userInfoPayload(accessToken);
      const response = await apiCall(payload);
      if (response?.data) {
        setUserInfoState({ status: SUCCESS, content: response.data });
        return response.data;
      }
      throw new Error(response);

    } catch (error) {
      setUserInfoState({ status: ERROR, content: {} });
    }
  };

  const clearUserInfoState = () => {
    setUserInfoState(USER_INFO_INITIAL_STATE);
  };
  return { status, content, fetchUserInfo, clearUserInfoState };
};

export default useFetchUserInfo;
